import './Button.css';

export default function Button({ onClick, className, disabled = false, children, ...rest }) {
    return (
        <button
            onClick={onClick}
            className={`btn ${className ?? ''}`}
            disabled={disabled}
            {...rest}
        >
            {children}
        </button>
    )
}
